import React, {Component} from 'react';
import userImage from '../../assets/128x128.jpg';
import elf from '../../assets/img/elf.png';

import api from '../../utils/api';
import moment from 'moment';
import $ from 'jquery';
import {emojify} from 'react-emojione';
import 'emojione-picker/css/picker.css';
import EmojiPicker from 'emojione-picker';
import Linkify from 'linkifyjs/react';
import jwt from 'jsonwebtoken';

import {NotificationManager} from 'react-notifications';


class ThreadView extends Component {
    constructor(props){
        super(props);
        this.state = {
            socket: null,
            currentThread: null,
            currentMessageThread: {},
            content: '',
            sidebarOpened: false,
            loading: false,
            online: true,
            changingStatus: false,
            activeAttachmentView: 'Pictures',
            searchFiles: '',
            galleryActive: false,
            galleryIndex: 0,
            userSearch: ''
        }
    }
    
    
    sendMessage = (e) => {
        let self = this;
        let splitLines = this.state.content.split('\n').filter(l => l !== '');
        e.preventDefault();
        
        if(this.props.uploadingMessageFiles.length > 0){
            NotificationManager.error('You have files uploading.  Please wait until these complete.');
        }else if(this.state.content !== '' && splitLines.length > 0 || this.props.messageFiles.length > 0){
            
            let command = jwt.sign({
                command: {
                    type: 'ADD_MESSAGE',
                    message: {
                        createdAt: new Date(),
                        status: "sent",
                        content: self.state.content,
                        threadId: self.props.currentThread,
                        profileId: self.props.user.user.Profile.id
                    },
                    messageFiles: this.props.messageFiles.map(f => f.id),
                    token: this.props.user.id
          
                }}, '#&r7%+UbWU8Hc');
                this.props.socket.send(command);
           
            
            this.props.clearMessageFiles();
            
            command = jwt.sign({
                command: {
                        type: 'IS_TYPING',
                        threadId: self.props.currentThread,
                        id: self.props.user.user.Profile.id,
                        typing: false,
                        token: self.props.user.id
              
                    }}, '#&r7%+UbWU8Hc');
                this.props.socket.send(command);
            
            this.setState({content: ''});
        }
    }
    
    updateInput = (e) => {
        let self = this;
        this.setState({content: e.target.value}, () => {
            let thread = {};
            let threadList = self.props.threads.filter(t => t.id === self.props.currentThread);
                
            if(threadList.length > 0){
                thread = threadList[0];
            }
            

            if(thread.typing){
            if(self.state.content !== '' && thread.typing.indexOf(self.props.user.user.Profile.id) === -1){

                   let command = jwt.sign({
                        command: {
                        type: 'IS_TYPING',
                        threadId: self.props.currentThread,
                        id: self.props.user.user.Profile.id,
                        typing: true,
                        token: self.props.user.id
              
                    }}, '#&r7%+UbWU8Hc');
                    this.props.socket.send(command);

            }else if(self.state.content === '' && thread.typing.indexOf(self.props.user.user.Profile.id) > -1){

               let command = jwt.sign({
                        command: {
                        type: 'IS_TYPING',
                        threadId: self.props.currentThread,
                        id: self.props.user.user.Profile.id,
                        typing: false,
                        token: self.props.user.id
              
                    }}, '#&r7%+UbWU8Hc');
                    this.props.socket.send(command);
            }
            }
        })
    }
    
    readFile = (file) => {
        var fr = new FileReader();
        fr.onload = function () {
            $('[data-file="'+ file.name +'"]').attr('src', fr.result);
        }
        fr.readAsDataURL(file);

    }
    

    loadMore = () => {
        
        if(this.props.socket && this.props.currentThread && this.state.loading === false){
            let thread = {};
            let threadList = this.props.threads.filter(t => t.id === this.props.match.params.threadId);
                
            if(threadList.length > 0){
                thread = threadList[0];
            }
            
            if(thread.Messages){
                this.setState({loading: true}, () => {
                    let command = jwt.sign({
                                    command: {
                        type: 'LOAD_MORE_MESSAGES',
                        profileId: this.props.user.user.Profile.id,
                        skip: thread.Messages.length,
                        threadId: thread.id,
                        initial: false,
                        token: this.props.user.id
                    }}, '#&r7%+UbWU8Hc');
                    this.props.socket.send(command);
                    this.props.resetUnread(thread.id);
                 
                })
            }
        }
    }
    
    showSeen = (message) => {
        let {thread, settings} = this.props;
        let studentToStudentSeen = settings.filter(s => s.name === "studentToStudentSeen")[0].value;
        let studentToInstructorSeen = settings.filter(s => s.name === "studentToInstructorSeen")[0].value;
        let instructorToStudentSeen = settings.filter(s => s.name === "instructorToStudentSeen")[0].value;
        let instructorToInstructorSeen = settings.filter(s => s.name === "instructorToInstructorSeen")[0].value;
        let showSeen = false;
        let showSeenPerMessage = false;
        
        if(thread && message.profileId === this.props.user.user.Profile.id){
            let msgProfile = thread.Profiles.filter(u => u.id === message.profileId)[0];
            let seenByInstructor = false;
                let seenByStudent = false;
                
                Object.keys(message.seenBy).map(p => {
                    if(thread.Profiles.filter(u => u.id === p)[0]){
                    let role = thread.Profiles.filter(u => u.id === p)[0].role;
                    if(role === 'instructor'){
                        seenByInstructor = true;
                    }else if(role == 'student'){
                        seenByStudent = true;
                    }
                }
                })
                
            
            if(thread.ticket || thread.subjectId){
                // ticket: no users
                
                
                if(this.props.user.user.Profile.role === 'instructor'){
                    // Is instructor
                    if((instructorToStudentSeen === true || instructorToStudentSeen === "true") && message.profileId === this.props.user.user.Profile.id && seenByStudent){
                        showSeen = true;
                    }else if((instructorToInstructorSeen === true || instructorToInstructorSeen === "true") && message.profileId === this.props.user.user.Profile.id && seenByInstructor){
                        showSeen = true;
                    }
                }else if(this.props.user.user.Profile.role === 'student'){
                    // Is student
                    if((studentToInstructorSeen === true || studentToInstructorSeen === "true") && message.profileId === this.props.user.user.Profile.id && seenByInstructor){
                        showSeen = true;
                    }
                    
                }
            }else if(thread.title !== "announcements"){
                // Thread is user to user
                let profile = thread.Profiles.filter(p => p.id !== this.props.user.user.Profile.id);
                if(profile.length > 0){
                    if((studentToStudentSeen === true || studentToStudentSeen === 'true') && message.profileId === this.props.user.user.Profile.id && seenByStudent){
                        showSeen = true;
                    }
                }
            }
        }
        
        if(showSeen){
            return (
                <span>
                    <i className="zmdi zmdi-check-all"></i> Seen
                </span>
            )
        }
    }
    
    render(){
        
        let {thread, settings} = this.props;
        const linkOptions = {
            target: '_blank'
        }
        
        
        return (
            <div className="chat-box">
                <div className="chat-head text-center">
                <div className="flex flex-justify-content-space-between">
                    <div>
                    {
                        thread &&
                        thread.Profiles &&
                        thread.ticket &&
                        thread.Subject ? 
                           
                            <div>
                                <h3>
                                    {thread.Subject.name}
                                </h3>
                                <p>{thread.question}</p>
                            </div>
                                
                        :
                        thread &&
                        thread.Profiles &&
                        thread.users &&
                        thread.users.filter(t => t !== this.props.user.user.Profile.id).map((typer, i) => {
                            let profile = thread.Profiles.filter(p => p.id == typer)[0];
                            
                            if(profile){
                                return (
                                    <div key={i}>
                                    <h3>
                                        {`${i > 0 ? ', ' + profile.name : profile.name}`}
                                    </h3>
                                    <p>
                                        {profile.online ? 
                                            <i className="zmdi zmdi-circle text-success" title="Online now" />
                                        : null}
                                    {(profile.online) ? '  Online' : 'Offline'}</p>
                                    </div>
                                )
                            }
                        })
                    }
              
                    
                    
                    </div>
                    <div className="flex">
                        <div className="dropdown">
                                    
                                    <button href="#" data-toggle="dropdown" className="btn btn-icon btn-round btn-default" aria-expanded="true"><i className="zmdi zmdi-settings"></i></button>
                                    
                                    
                                    {(this.props.user.user.Profile.role === 'instructor' || this.props.user.user.Profile.role === 'admin') && (thread.ticket &&
                                        thread.subjectId) &&
                                        <ul className="dropdown-menu pull-right">
                                            <li><a href="#" onClick={e => {
                                                
                                                let username = thread.Profiles.filter(p => p.role === 'student')[0] ? thread.Profiles.filter(p => p.role === 'student')[0].name : '99Point9 User';
                                                let command = jwt.sign({
                                                    command: {
                                                        type: 'REQUEST_RESOLVED',
                                                        message: {
                                                            createdAt: new Date(),
                                                            status: "sent",
                                                            solvedRequest: true,
                                                            content: "Hey " + username + "! Does that seem to answer your question? If yes, then I'll let the instructors know.",
                                                            threadId: this.props.currentThread,
                                                            profileId: this.props.user.user.Profile.id
                                                        },
                                                        messageFiles: this.props.messageFiles.map(f => f.id),
                                                        token: this.props.user.id
                                              
                                                    }}, '#&r7%+UbWU8Hc');
                                                    this.props.socket.send(command);
                                                
                                            }}>Resolve Ticket</a> </li>
                                            <li><a href="#">Mark question in wrong chat</a> </li>
                                            <li><a href="#" onClick={e => {
                                                e.preventDefault();
                                                let command = jwt.sign({
                                                        command: {
                                                        type: 'TICKET_CLOSED',
                                                        threadId: thread.id,
                                                        id: this.props.user.user.Profile.id,
                                                        token: this.props.user.id
                                              
                                                    }}, '#&r7%+UbWU8Hc');
                                                    this.props.socket.send(command);
                                            }}>Dismiss Ticket</a> </li>
                                            <li><a href="#">Change Ticket Channel</a> </li>
                                        </ul>
                                        }
                                        
                                        
                                        {this.props.user.user.Profile.role === 'student' && !thread.subjectId && !thread.title && thread &&
                                            <ul className="dropdown-menu pull-right">
                                                <li><a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    let command = null;
                                                    if(thread.mutedBy.indexOf(this.props.user.user.Profile.id) === -1){
                                                       command = jwt.sign({
                                                            command: {
                                                                type: 'MUTE_THREAD',
                                                                mute: true,
                                                                threadId: thread.id,
                                                                profileId: this.props.user.user.Profile.id,
                                                                token: this.props.user.id
                                                  
                                                        }}, '#&r7%+UbWU8Hc'); 
                                                    }else{
                                                        command = jwt.sign({
                                                            command: {
                                                                type: 'MUTE_THREAD',
                                                                mute: false,
                                                                threadId: thread.id,
                                                                profileId: this.props.user.user.Profile.id,
                                                                token: this.props.user.id
                                                  
                                                        }}, '#&r7%+UbWU8Hc'); 
                                                    }
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    this.props.socket.send(command);
                                                    
                                                }}><i className="zmdi zmdi-volume-off"></i> {thread.mutedBy ? thread.mutedBy.indexOf(this.props.user.user.Profile.id) === -1 ? 'Mute' : 'Unmute' : 'Mute'}</a> </li>
                                                <li><a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    let command = null;
                                                    if(thread.blockedBy.indexOf(this.props.user.user.Profile.id) === -1){
                                                       command = jwt.sign({
                                                            command: {
                                                                type: 'BLOCK_THREAD',
                                                                block: true,
                                                                threadId: thread.id,
                                                                profileId: this.props.user.user.Profile.id,
                                                                token: this.props.user.id
                                                  
                                                        }}, '#&r7%+UbWU8Hc'); 
                                                    }else{
                                                        command = jwt.sign({
                                                            command: {
                                                                type: 'BLOCK_THREAD',
                                                                block: false,
                                                                threadId: thread.id,
                                                                profileId: this.props.user.user.Profile.id,
                                                                token: this.props.user.id
                                                  
                                                        }}, '#&r7%+UbWU8Hc'); 
                                                    }
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    this.props.socket.send(command);
                                                    
                                                }}><i className="zmdi zmdi-block"></i> {thread.blockedBy ? thread.blockedBy.indexOf(this.props.user.user.Profile.id) === -1 ? 'Block' : 'Unblock' : 'Block'}</a> </li>
                                                <li><a href="#"><i className="zmdi zmdi-circle-o"></i> Appear offline</a> </li>
                                                <li><a href="#"><i className="zmdi zmdi-bug"></i> Report harassment</a> </li>
                                                <li><a href="#"><i className="zmdi zmdi-check-all"></i> Turn off message receipt</a> </li>
                                            </ul>
                                        
                                        }
                                </div>

                            <button href="#" onClick={e => {
                                this.setState({sidebarOpened: !this.state.sidebarOpened});
                                    let command = jwt.sign({
                                        command: {
                                        type: 'LOAD_THREAD_FILES',
                                        profileId: this.props.user.user.Profile.id,
                                        threadId: this.props.currentThread,
                                        token: this.props.user.id
                                    }}, '#&r7%+UbWU8Hc');
                                        this.props.socket.send(command);
                             
                                
                            }} className="btn btn-icon btn-round btn-default"><i className="zmdi zmdi-attachment"></i></button>
                        </div>
                        </div>
                </div>
                <div className="chat-contents-wrapper">
                <div className="stacked-wrapped" style={{display: "none"}}>
                        <div className="chat-head text-center">
                            <div className="flex flex-justify-content-space-between">
                                <div>
                                    <h3 id="StackContentHeading">Announcements</h3>
                                    <div className="stacks-history">
                                        <div className="stack-history-item">
                                            <span>Total Questions Asked</span><span className="text-info">20</span>
                                        </div>
                                        <div className="stack-history-item">
                                            <span>Resolved</span><span className="text-success">12</span>
                                        </div>
                                        <div className="stack-history-item">
                                            <span>Unresolved</span><span className="text-orange">8</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="sp-top100">
                                    <div className="sp-50">
                                        <div className="wow fadeInUp animated">
                                            <div className="paper-stack" >
                                                <div className="flex">
                                                    <div className="paper-stack-subject-icon bg-physics">P</div>
                                                    <div className="sp-left10">
                                                        <h3><a href="#">Lecture 1</a></h3>
                                                        <p><a href="#">Precarious beyond ouch armadillo as accurate expediently the begrudging activated jeepers much hugged heron far noiseless allegedly ethereally usefully drew neglectfully poignantly save a oh far that </a></p>
                                                        <span className="label label-danger">12</span>
                                                        <i className="zmdi zmdi-chevron-right"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="wow fadeInUp animated" data-wow-delay="0.2s">
                                            <div className="paper-stack">
                                                <div className="flex">
                                                    <div className="paper-stack-subject-icon bg-physics">P</div>
                                                    <div className="sp-left10">
                                                        <h3><a href="#">Lecture 2</a></h3>
                                                        <p><a href="#">That shark porcupine more ladybug one leopard more dubiously and overslept unsociably less one music poked far wow poked this yikes less salmon dynamically much filled to meadowlark much less so where</a></p>
                                                        <div className="confirmed"><i className="zmdi zmdi-check-circle"></i> Resolved <span>12 Aug 2018</span></div>
                                                        <i className="zmdi zmdi-chevron-right"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="wow fadeInUp animated" data-wow-delay="0.4s" >
                                            <div className="paper-stack">
                                                <div className="flex">
                                                    <div className="paper-stack-subject-icon bg-physics">P</div>
                                                    <div className="sp-left10">
                                                        <h3><a href="#">Lecture 3</a></h3>
                                                        <p><a href="#">Preparatory where ran the facetious woodchuck until over wherever lantern about ouch more luridly overdid above musically much splashed alas meant strode one much far less sensible knitted saucily dre</a></p>
                                                        <span className="label label-danger">16</span>
                                                        <i className="zmdi zmdi-chevron-right"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="wow fadeInUp animated" data-wow-delay="0.6s" >
                                            <div className="paper-stack">
                                                <div className="flex">
                                                    <div className="paper-stack-subject-icon bg-physics">P</div>
                                                    <div className="sp-left10">
                                                        <h3><a href="#">Lecture 4</a></h3>
                                                        <p><a href="#">Some indiscreetly including after far unbound dispassionately petulant far bridled misled jeepers alongside marvelously but built leapt irrespective bound more remade far when noisily dear immaturely </a></p>
                                                        <span className="label label-danger">9</span>
                                                        <i className="zmdi zmdi-chevron-right"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="chat-footer-add-question">
                            <div className="chat-footer-add-question-wrapper">
                                <a href="#" className="HideAddFooterQuestion"><i className="zmdi zmdi-close"></i> </a>
                                <div className="container">
                                    
                                    <div className="row">
                                        <div className="col-sm-2 text-right">
                                            <p>What is this question about?</p>
                                        </div>
                                        <div className="col-sm-10">
                                            <div className="form-group">
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-2 text-right">

                                        </div>
                                        <div className="col-sm-6">
                                            <div className="QuestionTypeLecture">
                                                <select className="form-control">
                                                    <option value="">Choose One</option>
                                                    <option value=""></option>
                                                    <option value=""></option>
                                                    <option value=""></option>
                                                </select>
                                            </div>
                                            <div className="QuestionTypePracticeTest" style={{display: "none"}}>
                                                <input type="text" className="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-right">
                                <div className="sp-2000">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <textarea className="form-control" id="note"  placeholder="Type Your Question here"></textarea>
                                            <div className="chat-controls">
                                                <div className="visibleAfterClick">
                                                    <a href="#" className="btn btn-primary">Ask <i className="zmdi zmdi-mail-send"></i></a>
                                                </div>
                                                <a href="#" className="visibleBeforeClick"><i className="zmdi zmdi-image"></i> </a>
                                                <a href="#" className="text-red visibleBeforeClick"><i className="zmdi zmdi-mail-send"></i> </a>
                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul className="chat-items-wrapper" onScroll={e => {
                        
                        if(e.target.scrollTop === 0 && !this.state.loading){
                            
                            this.loadMore();
                        }
                    }}>
                    
                        {thread.Messages &&
                            thread.Messages.filter(m => m.content !== '' || m.MessageFiles.length > 0).map((m, i) => {
                            
                            let splitLines = m.content.split('\n').filter(l => l !== '');
                            let previousSplitLines = null;
                            
                            if(m.oldContent){
                                previousSplitLines = m.oldContent.split('\n').filter(l => l !== '');
                            }
                                let botName = this.props.settings.filter(s => s.name === 'botName')[0].value;
                            
                            
                                if(thread.title === 'announcements'){
                                    if(Object.keys(m.seenBy).indexOf(this.props.user.user.Profile.id) === -1){
                                                
                                        let command = jwt.sign({
                                          command: {
                                            type: 'MESSAGE_SEEN',
                                            messageId: m.id,
                                            profileId: this.props.user.user.Profile.id,
                                            when: new Date(),
                                            token: this.props.user.id
                                  
                                        }}, '#&r7%+UbWU8Hc');
                                        if(this.props.socket.readyState === 1){
                                            this.props.socket.send(command);
                                        }
                                    
                                    }
                                    
                                    return (
                                    <li className={`chat-item chat-item-right darkElf chat-item-announcement`}  key={i}>
                                        <div className="chat-item-content">
                                            <img src={elf} className="chat-avatar bounce2" />
                                                    
                                            <div className="chat-box-wrap">
                                                <div className="chat-box-wrapper">
                                                    <h3>{m.title}</h3>
                                                    
                                                    {splitLines.map((l, lindex) => {
                                                        return (
                                                            <Linkify key={lindex} tagName="p" options={linkOptions}>{emojify(l, {output: 'unicode'})}</Linkify>    
                                                        )
                                                    })
                                                    }
                                                    
                                                    {previousSplitLines && this.props.user.user.role === 'admin' &&
                                                        <div><h5>Deleted Message:</h5>
                                                        {previousSplitLines.map((l, lindex) => {
                                                            return (
                                                                <Linkify key={lindex} tagName="p" options={linkOptions}>{emojify(l, {output: 'unicode'})}</Linkify>    
                                                            )
                                                        })
                                                        }
                                                        </div>
                                                    }
                                                    
                                                    
                                                    
                                                    
                                                    <span className="chat-box-meta">
                                                    <span>{botName} - 99point9 Elf</span>
                                                        <span>{moment(m.date).fromNow()}</span>
                                                    </span>
                                                </div>
                                                <div className="MessageMenuWrapper">
                                                    
                                                </div>
                                            </div>
                                        </div>

                                        </li>
                                    )
                                }else if(m.solvedRequest || m.elf){
                                
                                    if(Object.keys(m.seenBy).indexOf(this.props.user.user.Profile.id) === -1){
                                                
                                                let command = jwt.sign({
                                                  command: {
                                                    type: 'MESSAGE_SEEN',
                                                    messageId: m.id,
                                                    profileId: this.props.user.user.Profile.id,
                                                    when: new Date(),
                                                    token: this.props.user.id
                                          
                                                }}, '#&r7%+UbWU8Hc');
                                                if(this.props.socket.readyState === 1){
                                                    this.props.socket.send(command);
                                                }
                                            
                                            }
                                    return (
                                    <li className={`chat-item chat-item-right darkElf`} key={i}>
                                        <div className="chat-item-content">
                                            <img src={elf} className="chat-avatar bounce2" />
                                                    
                                            <div className="chat-box-wrap">
                                                <div className="chat-box-wrapper">
                                                    
                                                    {splitLines.map((l, lindex) => {
                                                        return (
                                                            <Linkify key={lindex} tagName="p" options={linkOptions}>{emojify(l.replace('{name}', thread.Profiles[0] ? thread.Profiles[0].name : '99Point9 User'), {output: 'unicode'})}</Linkify>    
                                                        )
                                                    })
                                                    }
                                                    
                                                    {previousSplitLines && this.props.user.user.role === 'admin' &&
                                                        <div><h5>Deleted Message:</h5>
                                                        {previousSplitLines.map((l, lindex) => {
                                                            return (
                                                                <Linkify key={lindex} tagName="p" options={linkOptions}>{emojify(l, {output: 'unicode'})}</Linkify>    
                                                            )
                                                        })
                                                        }
                                                        </div>
                                                    }
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    <span className="chat-box-meta">
                                                    <span>{botName} - 99point9 Elf</span>
                                                        <span>{moment(m.createdAt).fromNow()}</span>
                                                    </span>
                                                </div>
                                                <div className="MessageMenuWrapper">
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {m.solvedRequest && !thread.solved && !thread.closed && this.props.user.user.Profile.role === 'student' &&
                                            <div className="sm-top60 text-center">
                                                <a href="#" onClick={e => {
                                                    e.preventDefault();
                                                     let command = jwt.sign({
                                                        command: {
                                                        type: 'TICKET_SOLVED',
                                                        threadId: thread.id,
                                                        id: this.props.user.user.Profile.id,
                                                        token: this.props.user.id
                                              
                                                    }}, '#&r7%+UbWU8Hc');
                                                    this.props.socket.send(command);
                                                    
                                                }} className="btn btn-success btn-rounded sm-right10"><i className="zmdi zmdi-thumb-up" style={{color: "#fffd06"}}></i> Yep! I'm good</a>
                                                <a href="#" className="btn btn-primary btn-rounded"><i className="zmdi zmdi-thumb-down" style={{color: "#fffd06"}}></i> I'm still confused. </a>
                                            </div>
                                            
                                        }
                                        </li>
                                    )
                                }else{
                                    if(!m.Profile){
                                        let profile = thread.Profiles.filter(p => p.id === m.profileId);
                                        if(profile.length > 0){
                                            m.Profile = profile[0];
                                        }
                                    }

                                    if(!m.Profile){
                                        m.Profile = {
                                            name: '99Point9 User',
                                            role: 'student',
                                            online: false,

                                        }
                                    }
                                    if(m.Profile && splitLines.length > 0 || m.MessageFiles.length > 0){
                                    if(m.profileId !== this.props.user.user.Profile.id){
                                        
                                        if(Object.keys(m.seenBy).indexOf(this.props.user.user.Profile.id) === -1){
                                            
                                            let command = jwt.sign({
                                              command: {
                                                type: 'MESSAGE_SEEN',
                                                messageId: m.id,
                                                profileId: this.props.user.user.Profile.id,
                                                when: new Date(),
                                                token: this.props.user.id
                                      
                                            }}, '#&r7%+UbWU8Hc');
                                            if(this.props.socket.readyState === 1){
                                                this.props.socket.send(command);
                                            }
                                        
                                        }
                                        
                                    }
                                    return (
                                        <li key={i} className={`chat-item ${(thread.subjectId && m.solvedRequest) ? 'chat-item-left darkElf' :
                                            ((m.Profile.id === this.props.user.user.Profile.id && !thread.subjectId) || 
                                            (thread.subjectId && m.Profile.role === 'student')
                                            ) ? 'chat-item-left' : 
                                            
                                            (thread.subjectId && m.Profile.role === 'instructor' || m.Profile.role === 'admin') ? 'chat-item-right' : 
                                            (!thread.subjectId && m.Profile.id !== this.props.user.user.Profile.id) ? 'chat-item-right' : 
                                            'chat-item-left'}`} 
                                            title={
        
                                                            m.seenBy &&
                                                                Object.keys(m.seenBy)[0] !== this.props.user.user.Profile.id &&
                                                             m.seenBy[Object.keys(m.seenBy)[0]] ?
                                                                'Seen ' + moment(m.seenBy[Object.keys(m.seenBy)[0]]).fromNow()
                                                                : null
                                                                
                                                                
                                                            
                                                        }>
                                            <div className="chat-item-content">
                                                {m.Profile.image ?
                                                            <span>
                                                                {m.Profile.image.indexOf('http') === -1 ?
                                                                    <img src={api.makeFileURL(m.Profile.image) || userImage} className="chat-avatar" />
                                                                :
                                                                    <img src={(m.Profile.image) ? m.Profile.image : userImage} className="chat-avatar" />
                                                                }
                                                            </span>
                                                            
                                                            :
                                                            <img src={(m.Profile.image) ? m.Profile.image : userImage} className="chat-avatar" />
                                                        }
                                                <div className="chat-box-wrap">
                                                    <div className="chat-box-wrapper">
                                                        
                                                        {splitLines.map((l, o) => {
                                                            return (
                                                                <Linkify key={o} tagName="p" options={linkOptions}>{emojify(l, {output: 'unicode'})}</Linkify>    
                                                            )
                                                        })
                                                        }
                                                        
                                                        {previousSplitLines && this.props.user.user.role === 'admin' &&
                                                            <div><h5>Deleted Message:</h5>
                                                            {previousSplitLines.map((l, lindex) => {
                                                                return (
                                                                    <Linkify key={lindex} tagName="p" options={linkOptions}>{emojify(l, {output: 'unicode'})}</Linkify>    
                                                                )
                                                            })
                                                            }
                                                            </div>
                                                        }
                                                        
                                                        
                                                        
                                                        {m.MessageFiles.filter(f => f.type !== "link").length > 0 &&
                                                            <div className="message-files row">
                                                                {m.MessageFiles.filter(f => f.type !== "link").map((f, fi) => {
                                                                
                                                                    if(f.type.indexOf('video') > -1){
                                                                        return (
                                                                            <div className="file-preview-container" key={fi}>
                                                                                    
                                                                                    <video controls className="message-video" data-file={f.name}>
                                                                                        <source src={api.makeFileURL(f.url)} type={f.type} />
                                                                                        </video>
                                                                                        </div>
                                                                        )
                                                                        
                                                                    }else if (f.type.indexOf("image") > -1) {
                                    
                                    
                                                                            return (
                                                                                <div className="file-preview-container" key={fi}>
                                                                                    
                                                                                    <img src={api.makeFileURL(f.url)} data-file={f.name}
                                                                                         className="chapter-file-preview"/></div>
                                                                            )
                                                                        } else if (f.type.indexOf("zip") > -1) {
                                                                            return (
                                                                                <a key={fi} className="file-preview-container icon-preview" target="_blank"
                                                                                   href={api.makeFileURL(f.url)}>
                                                                                    
                                                                                    <i className="zmdi zmdi-folder"/>
                                                                                    <small>{f.name}</small>
                        
                                                                                </a>
                                                                            )
                                                                        } else {
                                                                            return (
                                                                                <a key={fi} className="file-preview-container icon-preview" target="_blank"
                                                                                   href={api.makeFileURL(f.url)}>
                                                                                    
                                                                                    <i className="zmdi zmdi-file"/>
                                                                                    <small>{f.name}</small>
                        
                                                                                </a>
                                                                            )
                                                                        }
                                                                    })
                                                                }
                                                            </div>
                                                        }
                                                        <span className="chat-box-meta">
                                                        <span>{m.Profile.name} - {m.Profile.role}</span>
                                                            <span>{moment(m.createdAt).fromNow()}</span>
                                                        
                                                         {this.showSeen(m)}
                                                        </span>
                                                    </div>
                                                    
                                                    
                                                   
                                                    <div className="MessageMenuWrapper">
                                                        <div className="btn-group">
                                                            <div className="btn-group" role="group">
                                                                <a href="#" className="btn btn-default" data-toggle="dropdown"><i className="zmdi zmdi-more"></i> </a>
                                                                {m.Profile.id === this.props.user.user.Profile.id ?
                                                                    <ul className="dropdown-menu">
                                                                        <li><a href="#"><i className="zmdi zmdi-edit"></i> Edit</a></li>
                                                                        <li><a href="#" onClick={e => {
                                                                            e.preventDefault();
                                                                            
                                                                             let command = jwt.sign({
                                                                                command: {
                                                                                    type: 'DELETE_MESSAGE',
                                                                                    profileId: this.props.user.user.Profile.id,
                                                                                    threadId: this.props.currentThread,
                                                                                    messageId: m.id,
                                                                                    token: this.props.user.id
                                                                                }}, '#&r7%+UbWU8Hc');
                                                                                this.props.socket.send(command);
                                                                            
                                                                        }}><i className="zmdi zmdi-delete"></i> Delete</a></li>
                                                                        
                                                                        
                    
                                                                    </ul>
                                                                    
                                                                    :
                                                                    
                                                                    <ul className="dropdown-menu">
                                                                        
                                                                        <li><a href="#"><i className="zmdi zmdi-quote"></i> Quote</a></li>
                                                                        <li><a href="#" onClick={e => {
                                                                            e.preventDefault();
                                                                            let canReport = true;
                                                                            if(m.reportedBy){
                                                                                if(m.reportedBy.indexOf(this.props.user.user.Profile.id) > -1){
                                                                                    canReport = false;
                                                                                }
                                                                            }
                                                                            
                                                                            if(canReport){
                                                                             let command = jwt.sign({
                                                                                command: {
                                                                                    type: 'REPORT_COMMENT',
                                                                                    profileId: this.props.user.user.Profile.id,
                                                                                    threadId: this.props.currentThread,
                                                                                    messageId: m.id,
                                                                                    token: this.props.user.id
                                                                                }}, '#&r7%+UbWU8Hc');
                                                                                this.props.socket.send(command);
                                                                            }
                                                                        }}><i className="zmdi zmdi-mood-bad"></i> {m.reportedBy ? m.reportedBy.filter(r => r.by ===this.props.user.user.Profile.id).length > 0 ? "Reported": "Report as rude or inappropriate" : "Report as rude or inappropriate" }</a></li>
                    
                                                                    </ul>
                                                                }
                                                            </div>
                                                            <a href="#" className="btn btn-default"><i className="zmdi zmdi-mood"></i> </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {m.solvedRequest &&
                                                <div className="sm-top60 text-center">
                                                    <a href="#" className="btn btn-success btn-rounded sm-right10"><i className="zmdi zmdi-thumb-up" style={{color: "#fffd06"}}></i> Yep! I'm good</a>
                                                    <a href="#" className="btn btn-primary btn-rounded"><i className="zmdi zmdi-thumb-down" style={{color: "#fffd06"}}></i> I'm still confused. </a>
                                                </div>
                                                
                                            }
                                            </li>
                                        )
                                    }
                                
                                
                                
                                }
                            })
                        }
                                                                        
                        

                                                
                        


                                            </ul>
                </div>
                
                
                <div className="chatbox-input-area" style={{overflow: 'initial'}}>
                <span className="isTyping">
                        {
                            thread &&
                            thread.typing &&
                            thread.typing.length > 0 &&
                            thread.Profiles &&
                            thread.typing.filter(t => t !== this.props.user.user.Profile.id).map((typer, i) => {
                                let profile = {};
                                
                                profile = thread.Profiles.filter(p => p.id == typer)[0];
                                
                                if(profile){
                                    return (
                                        <span key={i}>
                                            {`${i > 0 ? ', ' + profile.name : profile.name}`}
                                        </span>
                                    )
                                }else{
                                    return (
                                        <span key={i}>An instructor</span>
                                    )
                                }
                            })
                            
                            
                        }
                        
                        {thread &&
                            thread.typing &&
                            thread.typing.length > 0 &&
                            thread.Profiles &&
                            thread.typing.filter(t => t !== this.props.user.user.Profile.id).length > 0 &&
                        <span>{`${(thread.typing.filter(t => t !== this.props.user.user.Profile.id).length > 1) ? ' are typing' : ' is typing'}`}</span>
                        }
                    </span>
                    <div className="chat-input">
                        <div className="chat-controls">
                            <a href="#" onClick={(e) => $('#upload-message-files').trigger('click')}><i className="zmdi zmdi-image"></i> </a>
                            <a href="#" onClick={(e) => $('#upload-message-files').trigger('click')}><i className="zmdi zmdi-file"></i> </a>
                            <input
                                type="file"
                                className="btn btn-file-upload btn-default hidden"
                                id="upload-message-files"
                                onChange={(e) => {
                                    let {files} = this.state;
                                    const data = new FormData();
                                    
                                    this.props.uploadMessageFiles(e.target.files, this.props.user.user.Profile.id, this.props.user.id);
                                    
                                }}
                                multiple={true}
                            />
                            <a href="#CreateNotificationModal" data-toggle="modal"><i className="zmdi zmdi-notifications-active"></i> </a>
                            <a href="#" onClick={e => this.sendMessage(e)}><i className="zmdi zmdi-mail-send"></i> </a>
                            <span className="dropdown emoji-dropdown">
                                <a className="dropdown-toggle" data-toggle="dropdown" href="#"><i className="zmdi zmdi-mood"></i></a>
                                <div className="dropdown-menu">
                                <EmojiPicker onChange={(data, e) => {
                                  
                                  this.setState({content: this.state.content + ' ' + data.shortname});
                                  return false;
                                }} search={true} />
                                </div>
                            </span>
                        </div>
                        {this.props.currentThread &&
                            this.props.threads.filter(t => t.id === this.props.currentThread).length > 0 &&
                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].title !== 'announcements' &&
                              !this.props.threads.filter(t => t.id === this.props.currentThread)[0].solved &&   
                              this.props.threads.filter(t => t.id === this.props.currentThread)[0].blockedBy.length === 0 &&
                        <textarea 
                            className="form-control emojiArea" 
                            placeholder="Type your message and hit enter to send"
                            value={this.state.content} 
                            onChange={e => this.updateInput(e)}
                            onKeyDown={e => {
                                if(e.which === 13 && e.shiftKey === false){
                                    this.sendMessage(e);
                                }
                                
                            }}
                            
                            ></textarea>
                        }
                            
                            <div className="files-temp row">
                            
                            {this.props.messageFiles.map((f, fi) => {
                                if (f.type.indexOf("image") > -1) {


                                                    return (
                                                        <div key={fi} className="file-preview-container">
                                                            <button className={"btn btn-delete"}
                                                                    onClick={(e) => {
                                                                        this.props.cancelMessageFile(f, this.props.user.user.Profile.id, this.props.user.id)
                                                                    }}
                                                            ><i className={"zmdi zmdi-close"}/></button>
                                                            <img src={api.makeFileURL(f.url)} data-file={f.name}
                                                                 className="chapter-file-preview"/></div>
                                                    )
                                                } else if (f.type.indexOf("zip") > -1) {
                                                    return (
                                                        <a key={fi} className="file-preview-container" target="_blank"
                                                           href={api.makeFileURL(f.url)}>
                                                            <button className={"btn btn-delete"}
                                                                    onClick={(e) => {
                                                                        this.props.cancelMessageFile(f, this.props.user.user.Profile.id, this.props.user.id)
                                                                    }}
                                                            ><i className={"zmdi zmdi-close"}/></button>
                                                            <i className="zmdi zmdi-folder"/>
                                                            <small>{f.name}</small>

                                                        </a>
                                                    )
                                                } else {
                                                    return (
                                                        <a key={fi} className="file-preview-container" target="_blank"
                                                           href={api.makeFileURL(f.url)}>
                                                            <button className={"btn btn-delete"}
                                                                    onClick={(e) => {
                                                                        this.props.cancelMessageFile(f, this.props.user.user.Profile.id, this.props.user.id)
                                                                    }}
                                                            ><i className={"zmdi zmdi-close"}/></button>
                                                            <i className="zmdi zmdi-file"/>
                                                            <small>{f.name}</small>

                                                        </a>
                                                    )
                                                }
                            })
                            }
                            
                            {this.props.uploadingMessageFiles.map((f, fi) => {
                                
                                        if(f.type.indexOf("image") > -1){
                                            this.readFile(f);
                                            return (
                                                <div key={fi} className="file-preview-container">
                                                    
                                                    <img src={""} data-file={f.name} className="chapter-file-preview" /></div>
                                            )
                                        }else if(f.type.indexOf("zip") > -1){
                                            return (
                                                <div key={fi} className="file-preview-container">
                                                    
                                                    <i className="zmdi zmdi-folder" />
                                                    <small>{f.name}</small>

                                                </div>
                                            )
                                        }else{
                                            return (
                                                <div key={fi} className="file-preview-container">
                                                    
                                                    <i className="zmdi zmdi-file" />
                                                    <small>{f.name}</small>

                                                </div>
                                            ) 
                                        }
                                    })}
                            </div>
                        </div>
                </div>
                <div className={`chat-sidebar-right ${(this.state.sidebarOpened) ? 'active-chat-sidebar-right' : ''}`} >
                    <div className="mycs">
                        <div className="myc myc1"></div>
                        <div className="myc myc2"></div>
                        <div className="myc myc3"></div>
                    </div>
                    <div className="sp-20 sidebar-body">
                        <div className="flex flex-justify-content-space-between flex-align-items-center">
                            <p className="no-margin font-20 text-white">Gallery</p>
                            <a href="#" className="font-22 line-height-1" onClick={e => this.setState({sidebarOpened: !this.state.sidebarOpened})}><i className="zmdi zmdi-close"></i> </a>
                        </div>
                        <div className="sm-top-bottom20 animateable animated fadeInRight">
                            <div className="form-group">
                                <select className="form-control" onChange={e => this.setState({activeAttachmentView: e.target.value})}>
                                    <option value="Pictures">Pictures</option>
                                    <option value="Files">Files</option>
                                    <option value="Links">Links</option>
                                </select>
                            </div>
                        </div>
                        <div className="sm-top-bottom20 animateable animated fadeInRight">
                            <div className="form-group">
                                <input type="text" className="form-control" placeholder="Search Files/Links" value={this.state.searchFiles} onChange={e => this.setState({searchFiles: e.target.value})}/>
                            </div>
                        </div>
                        <div className="sm-top-bottom20">
                            
                            <div className={`GalleryItem Gallery${this.state.activeAttachmentView}`} style={{display: 'block'}}>
                                <div className="chat-left-heading no-padding animateable wow  fadeInRight" data-wow-delay="0.1s" >
                                    <p>{this.state.activeAttachmentView}</p>
                                </div>
                                
                                {this.state.activeAttachmentView === 'Pictures' &&
                                    <div className="galleryPictureItems">
                                    
                                    
                                        {this.props.currentThread &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread).length > 0 &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.filter(f => {
                                                
                                                return (this.state.searchFiles !== '') ? f.type.indexOf('image') > -1 && f.name.toLowerCase().indexOf(this.state.searchFiles.toLowerCase()) > -1 : f.type.indexOf('image') > -1;
                                                
                                                
                                            }).map((f, i) => {
                                                return (
                                                    <div key={i} className="galleryPictureItem animateable wow  fadeInRight" data-wow-delay="0.1s" style={{visibility: "visible", animationDelay: `0.${i}s`}}>
                                                        <div className="galleryPictureItemMeta">
                                                            {f.createdAt}
                                                        </div>
                                                        <a href="#" ><img 
                                                            src={api.makeFileURL(f.url, this.props.user.id)} 
                                                            data-full-preview={api.makeFileURL(f.url, this.props.user.id)} 
                                                            title={f.name}
                                                            onClick={e => {
                                                                let newState = {galleryActive: true, galleryIndex: i};
                                                                this.setState(newState);
                                                                
                                                            }}    
                                                        /></a>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                                  
                                }
                                
                                
                                {this.state.activeAttachmentView === 'Files' &&
                                    <div className="galleryLinksItems">
                                    <ul>
                                        {this.props.currentThread &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread).length > 0 &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.filter(f => {
                                                
                                                return (this.state.searchFiles !== '') ? f.type.indexOf('image') === -1 && f.type !== "link" && f.name.toLowerCase().indexOf(this.state.searchFiles.toLowerCase()) > -1 : f.type.indexOf('image') === -1 && f.type !== "link";
                                                
                                                
                                            }).map((f, i) => {
                                            
                                                return (
                                                    <li key={i}><a href={api.makeFileURL(f.url, this.props.user.id)}>{f.name}</a><span className="listItemDateMeta">{f.createdAt}</span></li>        
                                                )
                                            })
                                        }
                                        
                                       
                                    </ul>
                                </div>
                                }
                                
                                
                                
                                {this.state.activeAttachmentView === 'Links' &&
                                    <div className="galleryLinksItems">
                                    <ul>
                                        {this.props.currentThread &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread).length > 0 &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.filter(f => {
                                                
                                                return (this.state.searchFiles !== '') ? (f.type.indexOf('image') === -1 && f.type === "link") && f.url.toLowerCase().indexOf(this.state.searchFiles.toLowerCase()) > -1 : f.type.indexOf('image') === -1 && f.type === "link";
                                                
                                                
                                            }).map((f, i) => {
                                            
                                                return (
                                                    <li key={i}><a href={f.url} target="_blank">{f.url}</a><span className="listItemDateMeta">{f.createdAt}</span></li>        
                                                )
                                            })
                                        }
                                        
                                       
                                    </ul>
                                </div>
                                }
                            </div>
                        </div>
                        <div className="">
                            <div className="sm-top20">
                                
                                    {this.props.currentThread && this.props.threads &&
                                        this.props.threads.filter(t => t.id === this.props.currentThread).length > 0 &&
                                        this.props.threads.filter(t => t.id === this.props.currentThread)[0].ticket ?
                                        <div>
                                        <div className="chat-left-heading no-padding  animateable wow  fadeInRight" data-wow-delay="0.6s">
                                            <p>Course Intructors</p>
                                        </div>
                                        <div className="peers_list">
                                        <ul>
                                        
                                            {this.props.threads.instructors ?
                                                this.props.thread.instructors.map((t, i) => {
                                                if(t){
                                                    let profile = t;
                                                    if(profile){
                                                      return (
                                                          <li key={i}>
                                                            
                                                                {profile.image ?
                                                                                <span>
                                                                                    {profile.image.indexOf('http') === -1 ?
                                                                                        <img src={api.makeFileURL(profile.image) || userImage}  />
                                                                                    :
                                                                                        <img src={(profile.image) ? profile.image : userImage}  />
                                                                                    }
                                                                                </span>
                                                                                
                                                                                :
                                                                                <img src={(profile.image) ? profile.image : userImage}  />
                                                                            }
                                                                <h3>{profile.name} {profile.lname}</h3>
                                                                
                                                             
                                                            </li>
                                                        )  
                                                    }
                                                }
                                                }) : null}
                                        </ul>
                                        </div>
                                        </div>
                                    :
                                    <div>
                                    <div className="chat-left-heading no-padding  animateable wow  fadeInRight" data-wow-delay="0.6s">
                                        <p>In this chat</p>
                                    </div>
                                    <div className="peers_list">
                                        <ul>
                                        {this.props.currentThread && this.props.threads &&
                                            
                                            this.props.threads.filter(t => t.id === this.props.currentThread).length > 0 &&
                                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].Profiles.map((t, i) => {
                                            if(t){
                                                let profile = t;
                                                if(profile){
                                                  return (
                                                      <li key={i}>
                                                        
                                                            {profile.image ?
                                                                            <span>
                                                                                {profile.image.indexOf('http') === -1 ?
                                                                                    <img src={api.makeFileURL(profile.image) || userImage}  />
                                                                                :
                                                                                    <img src={(profile.image) ? profile.image : userImage}  />
                                                                                }
                                                                            </span>
                                                                            
                                                                            :
                                                                            <img src={(profile.image) ? profile.image : userImage}  />
                                                                        }
                                                            <h3>{profile.name} {profile.lname}</h3>
                                                            
                                                         
                                                        </li>
                                                    )  
                                                }
                                            }
                                            })}
                                    </ul>
                                    </div>
                                    </div>
                                    }
                                
                            </div>
                        </div>
            
                        <div className={`GalleryItemPreviewWrapper ${!this.state.galleryActive && 'GalleryPreviewInactive'}`}>
                        {this.props.threads &&
                            this.props.threads.length > 0 &&
                            this.props.currentThread &&
                            this.props.threads.filter(t => t.id === this.props.currentThread).length > 0 &&
                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles &&
                            this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.filter(f => {
                                                
                                                return (this.state.searchFiles !== '') ? f.type.indexOf('image') > -1 && f.name.toLowerCase().indexOf(this.state.searchFiles.toLowerCase()) > -1 : f.type.indexOf('image') > -1;
                                                
                                                
                                            })[this.state.galleryIndex] &&
                                
                                <div className="GalleryItemPreview">
                                    <div className="GalleryItemPreviewControls">
                
                                        <a href="#" onClick={e => this.setState({galleryActive: false, galleryIndex: 0})} className="font-30 GalleryClose"><i className="zmdi zmdi-close"></i> </a>
                                        <a href="#" className="GalleryNext" onClick={e => {
                                            if(this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.filter(f => {
                                                
                                                return (this.state.searchFiles !== '') ? f.type.indexOf('image') > -1 && f.name.toLowerCase().indexOf(this.state.searchFiles.toLowerCase()) > -1 : f.type.indexOf('image') > -1;
                                                
                                                
                                            }).length - 1 > this.state.galleryIndex){
                                                this.setState({galleryIndex: this.state.galleryIndex + 1});
                                            }else{
                                                this.setState({galleryIndex: 0});
                                            }
                                        }}><i className="zmdi zmdi-chevron-right"></i> </a>
                                        <a href="#" className="GalleryPrev" onClick={e => {
                                        
                                            if(this.state.galleryIndex > 0){
                                                this.setState({galleryIndex: this.state.galleryIndex - 1});
                                            }else{
                                                this.setState({galleryIndex: this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.filter(f => {
                                                
                                                return (this.state.searchFiles !== '') ? f.type.indexOf('image') > -1 && f.name.toLowerCase().indexOf(this.state.searchFiles.toLowerCase()) > -1 : f.type.indexOf('image') > -1;
                                                
                                                
                                            }).length - 1});
                                            }
                                        }}><i className="zmdi zmdi-chevron-left"></i> </a>
                                    </div>
                                        
                                            <img src={api.makeFileURL(this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.filter(f => {
                                                
                                                return (this.state.searchFiles !== '') ? f.type.indexOf('image') > -1 && f.name.toLowerCase().indexOf(this.state.searchFiles.toLowerCase()) > -1 : f.type.indexOf('image') > -1;
                                                
                                                
                                            })[this.state.galleryIndex].url, this.props.user.id)} 
                                            id="GalleryImagePreviewItem" 
                                            title={this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.filter(f => {
                                                
                                                return (this.state.searchFiles !== '') ? f.type.indexOf('image') > -1 && f.name.toLowerCase().indexOf(this.state.searchFiles.toLowerCase()) > -1 : f.type.indexOf('image') > -1;
                                                
                                                
                                            })[this.state.galleryIndex].name} />
                                        
                                    <div className="GalleryImageMeta">
                                        <div className="">
                                            <h3 id="GalleryImageName">{this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.filter(f => {
                                                
                                                return (this.state.searchFiles !== '') ? f.type.indexOf('image') > -1 && f.name.toLowerCase().indexOf(this.state.searchFiles.toLowerCase()) > -1 : f.type.indexOf('image') > -1;
                                                
                                                
                                            })[this.state.galleryIndex].name}</h3>
                                        </div>
                                        <div>
                                            <a href={api.makeFileURL(this.props.threads.filter(t => t.id === this.props.currentThread)[0].ThreadFiles.filter(f => {
                                                
                                                return (this.state.searchFiles !== '') ? f.type.indexOf('image') > -1 && f.name.toLowerCase().indexOf(this.state.searchFiles.toLowerCase()) > -1 : f.type.indexOf('image') > -1;
                                                
                                                
                                            })[this.state.galleryIndex].url, this.props.user.id)} target="_blank" className="btn btn-primary GalleryDownload"><i className="zmdi zmdi-download"></i> Download</a>
                                        </div>
                                    </div>
                                </div>
                                
                        }
                        </div>
                    </div>
                </div>
                
                
                
            </div>
            )
    }
}

export default ThreadView;


// WEBPACK FOOTER //
// ./src/components/Chat/ThreadView.js